import useSWR from 'swr';
import server from '@/services/server';

const HEALTH_KEY = 'club/health';

/**
 * Saúde de personalização do clube (logo, WhatsApp, cartão, domínio ativo).
 * Não dispara o loading global do AppContext.
 */
export function useClubHealth(enabled = true) {
    const { data, error, mutate, isLoading, isValidating } = useSWR(
        enabled ? HEALTH_KEY : null,
        async () => {
            const response = await server.get(HEALTH_KEY);
            return response?.data?.data ?? null;
        },
        {
            revalidateOnFocus: true,
            dedupingInterval: 5000,
            errorRetryCount: 1,
        },
    );

    return {
        health: data,
        error,
        mutate,
        isLoading,
        isValidating,
        missingCount: data?.missingCount ?? 0,
        resellerPending: data?.resellerPending ?? 0,
        plansPending: data?.plansPending ?? 0,
        complete: Boolean(data?.complete),
    };
}

export { HEALTH_KEY as CLUB_HEALTH_SWR_KEY };
